import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/authStore'

const routes = [
  {
    path: '/',
    component: () => import("../layouts/default/DefaultLayout.vue"),
    children: [
      {
        path: "",
        name: 'AccommodationIndex',
        component: () => import("../views/AccommodationIndex.vue"),
        meta: { requiresAuth: true, title: 'Accommodations' },
      },
      {
        path: "accommodations/:id",
        name: 'AccommodationDetails',
        component: () => import("../views/AccommodationDetails.vue"),
        meta: { requiresAuth: true }, // Title set dynamically in component
      },
      // {
      //   path: "Accommodations-v2",
      //   name: 'AccommodationSecondIndex',
      //   component: () => import("../views/AccommodationSecondIndex.vue"),
      //   meta: { requiresAuth: true },
      // },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import("../views/ProfileView.vue"),
        meta: { requiresAuth: true, title: 'My Profile' },
      }
    ]
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: () => import("../layouts/admin/AdminDashboardLayout.vue"),
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: '',
        name: 'AdminDashboardHome',
        component: () => import("../views/admin/AdminDashboardIndexView.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Admin Overview' },
      },
      {
        path: 'organisations',
        name: 'AdminDashboardOrganisations',
        component: () => import("../views/dashboard/OrganisationsView.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Organisations' },
      },
      {
        path: 'accommodations',
        name: 'AdminDashboardAccommodations',
        component: () => import("../views/dashboard/AccommodationsView.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Accommodations' },
      },
      {
        path: 'users',
        name: 'AdminDashboardUsers',
        component: () => import("../views/dashboard/UsersView.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Users' },
      },
      // REMOVED: /notifications route - functionality moved to notification dialog
      // {
      //   path: 'notifications',
      //   name: 'Notifications',
      //   component: () => import("../views/NotificationsPage.vue"),
      //   meta: { requiresAuth: true },
      // },
      {
        path: 'amenities',
        name: 'AdminDashboardAmenities',
        component: () => import("../views/dashboard/AmenityView.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Amenities' },
      },
      {
        path: 'access-logs',
        name: 'AdminDashboardAccessLogs',
        component: () => import("../views/admin/AccessLogsView.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Access Log' },
      },
      {
        path: 'analytics/users',
        name: 'AdminDashboardAnalyticsUsers',
        component: () => import("../views/admin/AnalyticsView.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Analytics - Users' },
      },
      {
        path: 'analytics/accommodation-views',
        name: 'AdminDashboardAnalyticsAccommodationViews',
        component: () => import("../views/admin/AnalyticsView.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Analytics - Accommodation Views' },
      },
      {
        path: 'analytics/compliance',
        name: 'AdminDashboardAnalyticsCompliance',
        component: () => import("../views/admin/AnalyticsView.vue"),
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Analytics - Compliance' },
      },
      {
        path: 'analytics',
        name: 'AdminDashboardAnalytics',
        redirect: { name: 'AdminDashboardAnalyticsUsers' },
      },
    ]
  },
  {
    path: '/accommodations/:id/edit/:step?',
    name: 'DashboardAccommodationEdit',
    component: () => import("../views/dashboard/AccommodationFormPage.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Edit Accommodation' },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import("../layouts/dashboard/OrganisationDashboardLayout.vue"),
    meta: { requiresAuth: true, requiresManager: true },
    children: [
      {
        path: 'organisations/:id',
        name: 'DashboardOrganisationOverview',
        component: () => import("../views/dashboard/OrganisationOverviewView.vue"),
        meta: { requiresAuth: true, requiresManager: true, requiresOrgAccess: true, title: 'Organisation Overview' },
      },
      {
        path: 'organisations/:id/users',
        name: 'DashboardOrganisationUsers',
        component: () => import("../views/dashboard/UsersView.vue"),
        meta: { requiresAuth: true, requiresManager: true, requiresOrgAccess: true, title: 'Organisation Users' },
      },
      {
        path: 'organisations/:id/user-invitations',
        name: 'DashboardOrganisationUserInvitations',
        component: () => import("../views/dashboard/UsersView.vue"),
        meta: { requiresAuth: true, requiresManager: true, requiresOrgAccess: true, title: 'Organisation Invitations' },
      },
      {
        path: 'organisations/:id/teams',
        name: 'DashboardOrganisationTeams',
        component: () => import("../views/dashboard/OrganisationTeamsView.vue"),
        meta: { requiresAuth: true, requiresManager: true, requiresOrgAccess: true, title: 'Organisation Teams' },
      },
      {
        path: 'account',
        name: 'DashboardAccount',
        component: () => import("../views/dashboard/AccountView.vue"),
        meta: { requiresAuth: true, requiresManager: true, title: 'Account Settings' },
      },
    ]
  },
  {
    path: '/dashboard/teams',
    name: 'TeamDashboard',
    component: () => import("../layouts/team/TeamDashboardLayout.vue"),
    meta: { requiresAuth: true, requiresManager: true },
    children: [
      {
        path: ':id',
        name: 'DashboardTeamOverview',
        component: () => import("../views/team/TeamOverviewView.vue"),
        meta: { requiresAuth: true, requiresManager: true, requiresOrgAccess: true, title: 'Team Overview' },
      },
      {
        path: ':id/accommodations',
        redirect: { name: 'DashboardTeamAccommodationsFavourited' }
      },
      {
        path: ':id/accommodations/favourited',
        name: 'DashboardTeamAccommodationsFavourited',
        component: () => import("../views/dashboard/TeamAccommodationsView.vue"),
        meta: { requiresAuth: true, requiresManager: true, requiresOrgAccess: true, title: 'Preferred Accommodations' },
      },
      {
        path: ':id/accommodations/all',
        name: 'DashboardTeamAccommodationsAll',
        component: () => import("../views/dashboard/TeamAccommodationsView.vue"),
        meta: { requiresAuth: true, requiresManager: true, requiresOrgAccess: true, title: 'All Accommodations' },
      },
      {
        path: ':id/users',
        name: 'DashboardTeamUsers',
        component: () => import("../views/dashboard/UsersView.vue"),
        meta: { requiresAuth: true, requiresManager: true, requiresOrgAccess: true, title: 'Team Users' },
      },
      {
        path: ':id/user-invitations',
        name: 'DashboardTeamUserInvitations',
        component: () => import("../views/dashboard/UsersView.vue"),
        meta: { requiresAuth: true, requiresManager: true, requiresOrgAccess: true, title: 'Team Invitations' },
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import("../views/LoginView.vue"),
    meta: { title: 'Login' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import("../views/NotFoundView.vue"),
    meta: { title: 'Page Not Found' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Custom scroll behavior for Vuetify layouts
  //
  // WHY THIS IS NEEDED:
  // Vuetify's <v-main scrollable> creates a custom scroll container instead of using the window.
  // When navigating between routes that share the same layout (e.g., AccommodationIndex → AccommodationDetails),
  // Vue reuses the layout component for performance, which preserves the scroll position in the v-main container.
  // This causes the new page to appear scrolled down instead of at the top.
  //
  // WHEN THIS IS REQUIRED:
  // - Navigation between child routes within the same parent layout (same v-main container is reused)
  // - Example: / → /accommodations/:id (both use DefaultLayout)
  //
  // WHEN THIS IS NOT NEEDED:
  // - Navigation between routes with different layouts (layout is destroyed and recreated)
  // - Example: /admin/accommodations → /accommodations/:id (AdminDashboardLayout → DefaultLayout)
  // - In this case, the new layout naturally starts at scroll position 0
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      // Wait for next tick to ensure DOM is updated
      setTimeout(() => {
        // Find the v-main__scroller element (actual scrollable element in Vuetify 3)
        const scrollers = [
          document.querySelector('.v-main__scroller'),
          document.querySelector('.v-main'),
          document.documentElement,
          document.body
        ]

        for (const scroller of scrollers) {
          if (scroller) {
            if (savedPosition) {
              scroller.scrollTop = savedPosition.top || 0
            } else {
              scroller.scrollTop = 0
            }
            break
          }
        }

        resolve(savedPosition || { top: 0 })
      }, 50)
    })
  },
})


// Domain redirect configuration
const domainRedirectConfig = {
  // Enable redirect for different environments
  development: {
    enabled: true,
    // Azure app registration only allows http when using localhost (without `www` subdomain)
    from: 'www.localhost', 
    to: 'localhost'
  },
  // Future configuration for other environments
  staging: {
    enabled: false,
    from: 'staging.yourdomain.com',
    to: 'www.staging.yourdomain.com'
  },
  production: {
    enabled: false,
    from: 'yourdomain.com',
    to: 'www.yourdomain.com'
  }
}

// Helper function to get current environment
function getCurrentEnvironment() {
  return process.env.NODE_ENV;
}

// Helper function to check and perform domain redirect
function checkDomainRedirect() {
  const currentEnv = getCurrentEnvironment()
  const config = domainRedirectConfig[currentEnv]
  
  if (!config || !config.enabled) {
    return false
  }
  
  const currentHost = window.location.host
  const currentProtocol = window.location.protocol
  const currentPath = window.location.pathname + window.location.search + window.location.hash
  
  // Check if we need to redirect (domain matches 'from' but doesn't already have 'to' prefix)
  if (currentHost.startsWith(config.from) && !currentHost.startsWith(config.to)) {
    const newHost = currentHost.replace(config.from, config.to)
    const newUrl = `${currentProtocol}//${newHost}${currentPath}`
    
    console.log(`Domain redirect: ${window.location.href} → ${newUrl}`)
    window.location.replace(newUrl)
    return true
  }
  
  return false
}

// Navigation guard for domain redirect and authentication
router.beforeEach(async (to, from, next) => {
  // console.log(`🔄 ROUTER GUARD START: ${from.path} → ${to.path}`)

  // Skip domain redirect if MSAL is processing a redirect response (hash contains auth tokens)
  const hasMsalHash = window.location.hash && (
    window.location.hash.includes('id_token=') ||
    window.location.hash.includes('access_token=') ||
    window.location.hash.includes('code=') ||
    window.location.hash.includes('error=')
  )

  // Check for domain redirect first (but skip if MSAL is handling auth redirect)
  if (!hasMsalHash && checkDomainRedirect()) {
    console.log('🌐 Domain redirect triggered')
    // Redirect is happening, don't proceed with navigation
    return
  }
  
  // const authStore = useAuthStore()

  try {
    const authStore = useAuthStore()
    
    // Wait for auth initialization to complete before checking auth state.
    // Since the app is already mounted, the user sees the page layout
    // (not a blank page) while this await resolves.
    if (authStore.loading) {
      console.log('⏳ Auth still loading, waiting for initialization...')
      const result = await Promise.race([
        authStore.initPromise.then(() => 'done'),
        new Promise(resolve => setTimeout(() => resolve('timeout'), 10000)),
      ])
      if (result === 'timeout') {
        console.warn('⚠️ Auth initialization timed out after 10s, proceeding with current auth state')
      } else {
        console.log('✅ Auth initialization completed')
      }
    }

    const isAuthenticated = authStore.isAuthenticated
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const requiresManager = to.matched.some(record => record.meta.requiresManager)
    const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)

    console.log('Router guard:', {
      to: to.path,
      toName: to.name,
      from: from.path,
      fromName: from.name,
      requiresAuth,
      requiresManager,
      requiresAdmin,
      isAuthenticated,
      loading: authStore.loading,
      user: authStore.user?.username || 'none',
      hasManagerRole: authStore.hasRole('Managers'),
      hasAdminRole: authStore.hasRole('Administrators'),
      roles: authStore.roles
    })

    if (requiresAuth && !isAuthenticated) {
      // Redirect to login if route requires auth and user is not authenticated
      console.log('Redirecting to login - authentication required')
      next('/login')
    } else if (to.name === 'Login' && isAuthenticated) {
      // Redirect to home if user is already authenticated and tries to access login
      console.log('Redirecting to home - already authenticated')
      next('/')
    } else if (requiresAdmin && !authStore.hasRole('Administrators')) {
      console.warn('Access denied - Administrators only route')
      next('/')
    } else if (requiresManager && !authStore.hasRole('Managers') && !authStore.hasRole('Administrators')) {
      console.warn('Access denied - Managers only route')
      next('/')
    } else if (requiresManager && to.params.id && !authStore.hasRole('Administrators')) {
      // Check if manager (not admin) is trying to access an organization-specific resource
      // Ensure they can only access their own organization
      // Administrators can access any organization

      // Check if route requires organization access control using meta property
      const requiresOrgAccess = to.matched.some(record => record.meta.requiresOrgAccess)

      if (requiresOrgAccess) {
        const userOrgId = authStore.userProfile?.organisation?.id
        const requestedOrgId = to.params.id

        // Compare organization IDs (GUIDs) case-insensitively
        const normalizedUserOrgId = userOrgId?.toString().toLowerCase()
        const normalizedRequestedOrgId = requestedOrgId?.toString().toLowerCase()

        if (normalizedUserOrgId && normalizedRequestedOrgId && normalizedUserOrgId !== normalizedRequestedOrgId) {
          console.warn('Access denied - Manager attempting to access different organization')
          console.warn(`User org: ${userOrgId}, Requested org: ${requestedOrgId}`)
          // Redirect to their own organization dashboard
          next({ name: 'DashboardOrganisationOverview', params: { id: userOrgId } })
          return
        }
      }

      next()
    } else {
      next()
    }
  } catch (error) {
    console.error('Router guard error:', error)
    // On error, allow navigation but log the issue
    next()
  }
  // console.log(`🏁 ROUTER GUARD END: ${from.path} → ${to.path}`)
})

// Set document title after each navigation
router.afterEach((to) => {
  const baseTitle = 'EAMS'
  const pageTitle = to.meta?.title

  if (pageTitle) {
    document.title = `${pageTitle} | ${baseTitle}`
  } else {
    document.title = baseTitle
  }
})

export default router
